import { useCallback, useEffect, useMemo, useState } from 'react';
import { BUTTON_VARIANTS } from '../../constants/button-variants';
import { FEATURE_SWITCH_NAMES } from '../../constants/feature-switch-names';
import RedDot from '../../images/red-dot.svg';
import qualityEvents from '../../services/quality-events';
import Button from '../button/button';
import FontAwesomeIcon from '../font-awesome-icon/font-awesome-icon';
import { CLOSED_LIVE_SESSION_BANNER } from './live-session-bar.constants';
import './live-session-bar.scss';
import useFeatureSwitch from '../../hooks/use-feature-switch';

const LiveSessionBar = () => {
    const unleashData = useFeatureSwitch(FEATURE_SWITCH_NAMES.LIVE_SESSION_BAR, true) as UnleashRespT | undefined;

    const [showSessionBar, setShowSessionBar] = useState(Boolean(unleashData?.enabled));

    const variantData = useMemo(() => {
        try {
            return unleashData && JSON.parse(unleashData?.payload?.value);
        } catch (e) {
            setShowSessionBar(false);
        }
    }, [unleashData, setShowSessionBar]);

    const onClick = useCallback(() => {
        if (variantData?.link) {
            window.open(variantData.link, '_blank');

            qualityEvents.track({
                extra: JSON.stringify(Date.now()),
                type: FEATURE_SWITCH_NAMES.LIVE_SESSION_BAR,
                user_id: window.storage.getItem('userId')
            });
        }
    }, [variantData]);

    const currentBannerId = useCallback(() => {
        if (variantData?.id) {
            return `banner:${variantData.id}`;
        }
    }, [variantData]);

    const closeSpecialMessage = () => {
        window.storage.setItem(currentBannerId(), CLOSED_LIVE_SESSION_BANNER);
        setShowSessionBar(false);
    };

    // show popup logic
    useEffect(() => {
        try {
            const wasBannerClosed = window.storage.getItem(currentBannerId()) === CLOSED_LIVE_SESSION_BANNER;

            const currentDate = new Date().getTime();
            const startDate = Number(variantData?.startDate);
            const endDate = Number(variantData?.endDate);
            const isTimeBetweenRange = currentDate >= startDate && currentDate <= endDate;

            const isDateValid = startDate && endDate && isTimeBetweenRange;

            const showPopup = variantData && !wasBannerClosed && unleashData?.enabled && isDateValid;

            setShowSessionBar(showPopup);
        } catch (e) {
            setShowSessionBar((prev) => (prev ? false : prev));
        }
    }, [unleashData, variantData, setShowSessionBar, currentBannerId]);

    if (!showSessionBar) {
        return null;
    }

    return (
        <div className='live-session-bar d-flex align-items-center justify-content-center'>
            {variantData?.showDot && <img alt='red dot' src={RedDot} />}
            <div className='live-session-text'>{variantData.text}</div>
            <Button
                title={variantData.buttonText}
                variant={BUTTON_VARIANTS.TRANSPARENT}
                className='live-session-btn'
                onClick={onClick}
            >
                {variantData.buttonText}
            </Button>
            <span className='close-special' onClick={closeSpecialMessage}>
                <FontAwesomeIcon height={15} name='close' width={15} />
            </span>
        </div>
    );
};

export default LiveSessionBar;
